import { List, Timeline, Tag } from "antd";
import * as React from 'react';
export default {
  List,
  Timeline,
  Tag,
  React
};